import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryShowcase() {
  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            视频分类
          </h2>
          <p className="text-foreground-600 mt-3 text-sm max-w-xl mx-auto">
            六大精选分类，满足您对打屁股视频的多元化需求，点击进入感兴趣的栏目
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-lg overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-900">
                      {cat.name}
                    </h3>
                    <p className="text-foreground-500 text-xs">{cat.videoCount}个视频</p>
                  </div>
                </div>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}